<template>
    <my-ledger-form/>
</template>

<script>
export default {
components: {
    'my-ledger-form': () => import ('@/components/ledger'),
    
    
  },
}
</script>

<style>

</style>
